export const LOCATION_SHOW_DETAILS_TOGGLE_LOADING = 'LOCATION_SHOW_DETAILS_TOGGLE_LOADING'
export const LOCATION_SHOW_DATA = 'LOCATION_SHOW_DATA'
export const LOCATION_SHOW_OBSERVATIONS = 'LOCATION_SHOW_OBSERVATIONS'
export const LOCATION_SHOW_DETAILS_SET_ERROR = 'LOCATION_SHOW_DETAILS_SET_ERROR'
export const AREA_SHOW_SET_UPDATED= 'AREA_SHOW_SET_UPDATED'
